export default {"src":"/_next/static/media/facebook_icon.930bb0ab.svg","height":40,"width":40};